import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useEffect } from 'react';
import { string, arrayOf, func, bool, shape, oneOfType, number } from 'prop-types';
import FilterItem from '../../molecules/FilterItem';
import FilterItemContainer from '../FilterItemContainer';
import sortBySelected from '../../utils/sortBySelected';
export const filter = (input = '', items = []) => {
  return items.filter(item => {
    var _item$label, _item$label$toUpperCa;

    return (_item$label = item.label) == null ? void 0 : (_item$label$toUpperCa = _item$label.toUpperCase()) == null ? void 0 : _item$label$toUpperCa.includes(input.toUpperCase());
  });
};

const FilterItemAttribute = _ref => {
  let {
    fullScreen,
    label,
    position,
    filterSelected,
    items,
    showFilterInput,
    onItemClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["fullScreen", "label", "position", "filterSelected", "items", "showFilterInput", "onItemClick"]);

  const [filterItems, setFilterItems] = useState(sortBySelected(items));
  useEffect(() => {
    setFilterItems(sortBySelected(items));
    return () => setFilterItems([]);
  }, [items]);

  const handleClearInput = () => {
    setFilterItems(items);
  };

  const handleChangeFilterInput = e => {
    setFilterItems(sortBySelected(filter(e.target.value, items)));
  };

  return /*#__PURE__*/React.createElement(FilterItemContainer, _extends({}, props, {
    label: label,
    position: position,
    fullScreen: fullScreen,
    onChangeFilterInput: handleChangeFilterInput,
    onClearInput: handleClearInput,
    filterSelected: filterSelected,
    showFilterInput: showFilterInput
  }), /*#__PURE__*/React.createElement("ul", null, filterItems.map((item, idx) => /*#__PURE__*/React.createElement(FilterItem, {
    item: item,
    key: (item == null ? void 0 : item.slug) || idx,
    onClick: onItemClick
  }))));
};

FilterItemAttribute.defaultProps = {
  label: '',
  filterSelected: '',
  items: [],
  showFilterInput: false,
  onItemClick: () => ({})
};
process.env.NODE_ENV !== "production" ? FilterItemAttribute.propTypes = {
  label: string.isRequired,
  position: number,
  filterSelected: string,
  showFilterInput: bool,
  fullScreen: bool,
  items: arrayOf(shape({
    slug: oneOfType([string, number]),
    label: oneOfType([string, number])
  })).isRequired,
  onItemClick: func
} : void 0;
export default FilterItemAttribute;